import type React from 'react';

export const textWeights = ['regular', 'medium', 'semiBold', 'bold'] as const;
export type TextWeights = (typeof textWeights)[number];

export const textTransforms = [
  'uppercase',
  'lowercase',
  'capitalize',
  'none',
] as const;
export type TextTransforms = (typeof textTransforms)[number];

export const textColours = [
  'red',
  'white',
  'blue',
  'green',
  'errorPrimary',
  'textPrimary',
  'textSecondary',
  'primary',
  'purple300',
  'purple700',
  'grey050',
  'grey300',
  'grey700',
  'grey900',
  'blue300',
  'blue500',
  'blue700',
  'inherit',
] as const;
export type TextColours = (typeof textColours)[number];

export function createBaseStyles({
  maxLines,
  inline,
  overrideColour,
}: {
  maxLines?: number;
  inline?: boolean;
  overrideColour?: string;
}): React.CSSProperties {
  const styles: React.CSSProperties = {
    ...(overrideColour && {color: overrideColour}),
  };

  if (maxLines) {
    styles.WebkitBoxOrient = 'vertical';
    styles.WebkitLineClamp = maxLines;
    styles.display = '-webkit-box';
    styles.overflow = 'hidden';
  }
  if (inline) {
    styles.display = 'inline';
  }

  return styles;
}
